import * as l from "react";
const c = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "VG_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ l.createElement("g", { mask: "url(#VG_svg__a)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "VG_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#VG_svg__b)" }, /* @__PURE__ */ l.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "VG_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ l.createElement("g", { mask: "url(#VG_svg__c)" }, /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "mask",
    {
      id: "VG_svg__d",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ l.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ l.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#VG_svg__d)"
    }
  )), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.246 10.032v6.53s-.097 5.401 4.882 5.401 4.979-5.402 4.979-5.402v-6.529h-9.861z",
      fill: "#3B7E05",
      stroke: "#F7FCFF",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.236 19.888l.793-.796c1.24 1.53 2.544 2.276 3.93 2.276 1.386 0 2.689-.745 3.926-2.276l.453.454.02-.03c.275.234.457.453.544.706.143.413-.01.81-.343 1.019-.082.052-.148.09-.207.117a.521.521 0 01-.405.045.581.581 0 01-.373-.348c-1.125.996-2.333 1.502-3.615 1.502-1.271 0-2.469-.497-3.587-1.475a.58.58 0 01-.377.336.52.52 0 01-.404-.052 1.93 1.93 0 01-.205-.12c-.33-.216-.475-.615-.325-1.025.04-.111.105-.215.19-.315l-.015-.018z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M21.03 19.092l.194-.157-.176-.217-.196.197.177.177zm-.794.796l-.177-.176-.159.159.142.174.194-.157zm8.65-.796l.176-.176-.196-.197-.175.216.194.157zm.452.454l-.177.176.214.215.17-.252-.207-.14zm.02-.03l.16-.19-.212-.18-.156.23.207.14zm.544.706l.237-.081-.237.081zm-.343 1.019l-.133-.212.133.212zm-.207.117l-.105-.227.105.227zm-.405.045l.068-.241-.068.24zm-.373-.348l.231-.094-.133-.326-.264.233.166.187zm-7.202.027l.165-.188-.256-.225-.137.313.229.1zm-.377.336l.064.241-.064-.241zm-.404-.052l.11-.225-.11.225zm-.205-.12l-.137.209.137-.21zm-.325-1.025l.235.085-.235-.085zm.19-.315l.191.16.133-.157-.13-.16-.194.157zm.601-.99l-.793.796.354.352.793-.796-.354-.353zm4.107 2.202c-1.285 0-2.524-.687-3.735-2.183l-.39.314c1.268 1.565 2.637 2.369 4.125 2.369v-.5zm3.732-2.183c-1.21 1.496-2.448 2.183-3.732 2.183v.5c1.488 0 2.855-.804 4.12-2.369l-.388-.314zm.824.434l-.453-.453-.354.353.453.453.354-.353zm-.365.008l-.02.029.415.28.02-.03-.415-.28zm.989.764c-.109-.315-.33-.569-.62-.815l-.323.382c.26.22.404.404.47.596l.473-.163zm-.447 1.312c.433-.273.627-.79.447-1.312l-.473.163c.105.303-.005.578-.24.725l.266.424zm-.234.131c.072-.033.148-.077.234-.131l-.266-.424a1.67 1.67 0 01-.18.102l.212.453zm-.578.06a.753.753 0 00.578-.06l-.211-.453a.443.443 0 01-.122.042.255.255 0 01-.11-.011l-.135.481zm-.538-.494a.83.83 0 00.538.493l.135-.481a.332.332 0 01-.21-.201l-.463.189zm-3.383 1.657c1.354 0 2.619-.537 3.78-1.564l-.33-.375c-1.09.963-2.24 1.439-3.45 1.439v.5zm-3.751-1.537c1.154 1.01 2.409 1.537 3.75 1.537v-.5c-1.199 0-2.34-.467-3.42-1.413l-.33.376zm-.15.39a.83.83 0 00.543-.478l-.457-.2a.331.331 0 01-.213.194l.128.483zm-.576-.07a.924.924 0 00.261.089.75.75 0 00.316-.02l-.128-.483a.254.254 0 01-.11.01.44.44 0 01-.12-.045l-.22.45zm-.233-.136c.086.056.16.101.233.136l.218-.45a1.669 1.669 0 01-.177-.104l-.274.418zm-.423-1.319c-.19.518-.004 1.04.423 1.32l.274-.419c-.232-.152-.337-.428-.227-.73l-.47-.17zm.233-.39c-.097.116-.18.245-.233.39l.47.171a.807.807 0 01.146-.24l-.383-.32zm-.017.3l.015.019.388-.316-.015-.017-.388.314z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.956 11.46l.112.04c.09-.207.106-.366 0-.467l-.003-.005c-.025-.039-.069-.107.003-.253l-.051-.105c-.104.212-.15.365-.07.468l.005.005.004.005c.047.042.067.16 0 .312zm0 1.514l.112.04c.09-.207.106-.366 0-.468l-.003-.004c-.025-.039-.069-.107.003-.254l-.051-.104c-.104.212-.15.364-.07.468l.005.005.004.004c.047.042.067.16 0 .313zm.112 1.392l-.112-.04c.067-.153.047-.271 0-.313l-.005-.005-.004-.005c-.08-.103-.034-.256.07-.468l.05.105c-.07.146-.027.215-.002.253l.003.005c.106.102.09.26 0 .468zm.664 1.58l.111.041c.091-.208.106-.366 0-.468l-.003-.005c-.025-.038-.069-.107.003-.253l-.05-.105c-.104.212-.151.365-.07.468l.004.005.005.005c.047.042.066.16 0 .312zm-.81 1.339l-.112-.04c.067-.153.047-.271 0-.313l-.005-.005-.004-.005c-.081-.103-.034-.256.07-.468l.05.105c-.071.146-.027.215-.003.253l.003.005c.106.102.091.26 0 .468zm-.112 1.472l.111.04c.091-.207.106-.366 0-.467l-.003-.005c-.024-.039-.068-.107.003-.254l-.05-.104c-.104.212-.151.365-.07.468l.004.005.005.004c.047.043.067.16 0 .313zm4.918.04l-.111-.04c.066-.152.046-.27 0-.313l-.005-.004-.004-.005c-.081-.103-.035-.256.069-.468l.05.104c-.07.147-.027.215-.002.254l.003.005c.106.101.09.26 0 .468zm-.111-1.5l.11.042c.092-.208.107-.367 0-.468l-.002-.005c-.025-.039-.069-.107.003-.254l-.051-.104c-.104.212-.15.365-.07.468l.005.005.005.004c.046.043.066.16 0 .313zm.11-1.418l-.11-.041c.066-.152.046-.27 0-.313l-.005-.004-.004-.005c-.081-.103-.035-.256.069-.468l.05.104c-.07.147-.027.215-.002.254l.003.005c.106.101.09.26 0 .468zm-.16-1.446l.112.04c.09-.208.106-.366 0-.468l-.003-.004c-.025-.039-.068-.107.003-.254l-.051-.104c-.104.211-.15.364-.07.467l.005.006.005.004c.047.042.066.16 0 .313zm.112-1.473l-.111-.041c.066-.152.047-.27 0-.313l-.005-.004-.004-.005c-.081-.103-.035-.256.069-.468l.051.104c-.071.147-.028.215-.003.254l.003.005c.106.101.09.26 0 .468zm-.111-1.446l.111.04c.09-.207.106-.366 0-.468a.09.09 0 00-.003-.004c-.025-.039-.068-.107.003-.254l-.051-.104c-.104.211-.15.364-.07.468l.005.005.005.004c.047.042.066.16 0 .313z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.76 10.813a.116.116 0 00.012-.052c0-.06-.044-.108-.1-.108-.055 0-.1.049-.1.108 0 .026.009.05.023.069l-.378.585.04.032.377-.585a.093.093 0 00.092-.01l.398.595.039-.032-.403-.602zm-.013.507a.113.113 0 00.025-.072c0-.06-.044-.108-.1-.108-.055 0-.1.048-.1.108 0 .037.017.07.044.089l-.095.113h-.642s.07.161.29.204c.066.063.237.181.237.181l-.097.119H23v-.119c.17 0 .232-.134.255-.182.01-.02.012-.024.012 0 0 .086.123 0 .123 0s.205-.203.205-.397-.428.194-.428.194h-.29l-.131-.13zm-.868 1.644h.642l.095-.114a.11.11 0 01-.044-.089c0-.06.045-.108.1-.108.055 0 .1.049.1.108 0 .028-.01.053-.025.073l.13.13h.29s.428-.388.428-.194-.204.397-.204.397-.123.085-.123 0c0-.025-.003-.02-.012 0-.023.048-.086.18-.255.182v.119h-.692l.097-.119s-.17-.118-.238-.182a.397.397 0 01-.29-.203zm.88-.637a.115.115 0 00.013-.052c0-.06-.044-.108-.1-.108-.055 0-.1.048-.1.108 0 .026.009.05.023.069l-.378.585.04.032.377-.586a.093.093 0 00.092-.008l.398.594.039-.032-.403-.602zm-.88 1.988h.642l.095-.113a.11.11 0 01-.044-.089c0-.06.045-.108.1-.108.055 0 .1.048.1.108 0 .028-.01.053-.025.072l.13.13h.29s.428-.388.428-.194-.204.398-.204.398-.123.085-.123 0c0-.025-.003-.02-.012 0-.023.047-.086.18-.255.182v.118h-.692l.097-.118s-.17-.119-.238-.182c-.219-.043-.29-.204-.29-.204zm.881-.637a.113.113 0 00.012-.051c0-.06-.044-.108-.1-.108-.055 0-.1.048-.1.108 0 .025.009.05.023.068l-.378.585.04.031.377-.585a.094.094 0 00.092-.008l.398.594.039-.033-.403-.6zm-.106 2.258h.643l.095-.114a.111.111 0 01-.042-.088c0-.06.044-.108.1-.108.055 0 .1.048.1.108 0 .028-.01.054-.027.073l.13.13h.29s.428-.389.428-.195-.205.398-.205.398-.123.085-.123 0c0-.025-.002-.02-.011 0-.023.047-.087.18-.255.182v.118h-.693l.098-.118s-.171-.119-.238-.182c-.22-.043-.29-.204-.29-.204zm.883-.636a.115.115 0 00.013-.052c0-.06-.045-.108-.1-.108-.055 0-.1.048-.1.108 0 .026.008.05.022.068l-.378.586.04.031.378-.585a.094.094 0 00.091-.009l.398.595.04-.032-.404-.602zm-1.805 1.934h.643l.095-.114a.11.11 0 01-.042-.088c0-.06.044-.108.1-.108.055 0 .1.048.1.108 0 .028-.01.054-.027.073l.13.13h.29s.428-.389.428-.195-.205.398-.205.398-.123.085-.123 0c0-.025-.002-.02-.011 0-.023.047-.086.18-.255.182v.118h-.693l.098-.118s-.171-.119-.238-.182a.397.397 0 01-.29-.204zm.884-.637a.115.115 0 00.012-.051c0-.06-.045-.108-.1-.108-.055 0-.1.048-.1.108 0 .025.008.05.022.068l-.378.585.04.031.377-.585a.094.094 0 00.092-.008l.398.594.04-.033-.403-.6zm-.884 2.15h.643l.095-.113a.11.11 0 01-.042-.088c0-.06.044-.108.1-.108.055 0 .1.048.1.108 0 .028-.01.053-.027.073l.13.129h.29s.428-.388.428-.194-.205.397-.205.397-.123.085-.123 0c0-.024-.002-.02-.011 0-.023.048-.086.181-.255.182v.119h-.693l.098-.119s-.171-.118-.238-.182c-.22-.042-.29-.203-.29-.203zm.883-.637a.115.115 0 00.013-.052c0-.06-.045-.108-.1-.108-.055 0-.1.049-.1.108 0 .026.008.05.022.069l-.378.585.04.032.378-.586a.093.093 0 00.091-.008l.398.594.04-.032-.404-.602zm3.924.638h.642l.095-.113a.11.11 0 01-.044-.09c0-.06.045-.108.1-.108.056 0 .1.049.1.109 0 .027-.01.053-.025.072l.13.13h.291s.428-.388.428-.194-.205.397-.205.397-.123.085-.123 0c0-.024-.002-.02-.012 0-.022.048-.086.181-.255.182v.119h-.692l.098-.119s-.172-.118-.239-.182c-.219-.042-.289-.203-.289-.203zm.881-.638a.114.114 0 00.012-.052c0-.06-.044-.108-.1-.108-.055 0-.1.049-.1.108 0 .026.009.05.023.07l-.378.585.04.031.378-.585a.093.093 0 00.09-.01l.4.595.038-.032-.403-.602zm-.88-.822h.642l.094-.113a.11.11 0 01-.044-.09c0-.06.045-.108.1-.108.056 0 .1.049.1.109 0 .027-.01.053-.025.072l.13.13h.291s.428-.388.428-.194-.205.397-.205.397-.123.085-.123 0c0-.024-.002-.02-.012 0-.022.048-.086.181-.255.182v.119h-.692l.098-.119s-.172-.118-.239-.181a.396.396 0 01-.289-.204zm.88-.637a.115.115 0 00.012-.052c0-.06-.044-.108-.1-.108-.055 0-.1.049-.1.108 0 .026.009.05.023.069l-.378.585.04.032.377-.586a.093.093 0 00.092-.008l.398.594.039-.032-.403-.602zm-.88-.822h.642l.094-.113a.11.11 0 01-.044-.09c0-.059.045-.107.1-.107.056 0 .1.048.1.108 0 .027-.01.053-.025.072l.13.13h.291s.428-.388.428-.194-.205.397-.205.397-.123.085-.123 0c0-.024-.002-.02-.012 0-.022.048-.086.181-.255.182v.119h-.692l.098-.119s-.172-.118-.239-.181a.396.396 0 01-.289-.204zm.88-.638a.114.114 0 00.012-.052c0-.06-.044-.108-.1-.108-.055 0-.1.049-.1.108 0 .027.009.05.023.07l-.378.585.04.031.378-.585a.094.094 0 00.091-.009l.398.595.04-.033-.404-.601zm-.93-.768h.643l.095-.114a.11.11 0 01-.043-.089c0-.06.045-.108.1-.108.056 0 .1.049.1.108 0 .029-.01.054-.026.074l.13.129h.29s.428-.388.428-.194-.205.397-.205.397-.123.085-.123 0c0-.025-.002-.02-.012 0-.022.048-.086.18-.254.182v.119h-.693l.098-.119s-.172-.118-.238-.182c-.22-.042-.29-.203-.29-.203zm.882-.635a.115.115 0 00.014-.054c0-.06-.045-.108-.1-.108-.056 0-.1.048-.1.108 0 .025.008.049.021.067l-.379.587.04.032.378-.586a.094.094 0 00.091-.008l.398.594.04-.032-.403-.6zm-.882-.878h.643l.095-.114a.11.11 0 01-.043-.088c0-.06.045-.108.1-.108.056 0 .1.048.1.108 0 .028-.01.054-.026.073l.13.129h.29s.428-.388.428-.194-.205.398-.205.398-.123.085-.123 0c0-.025-.002-.02-.012 0-.022.047-.086.18-.254.181v.119h-.693l.098-.119s-.172-.118-.238-.181c-.22-.043-.29-.204-.29-.204zm.882-.636a.115.115 0 00.014-.054c0-.06-.045-.108-.1-.108-.056 0-.1.049-.1.108 0 .026.008.05.021.068l-.379.586.04.032.378-.586a.094.094 0 00.091-.007l.398.593.04-.032-.403-.6z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.64 12.585l-.337 1.093s-.563.73-.667 1.087c-.104.357-.161.594-.133.594a.371.371 0 00.26-.348c0-.246.877-1.039.877-1.039l.261-1.387h-.261z",
      fill: "#FFC6B5"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.373 10.867a.114.114 0 00.012-.052c0-.06-.044-.108-.1-.108-.055 0-.1.048-.1.108 0 .026.009.05.023.069l-.378.585.04.032.378-.586a.093.093 0 00.09-.008l.4.594.038-.032-.403-.602zm-.014.508a.113.113 0 00.026-.073c0-.06-.044-.109-.1-.109-.055 0-.1.049-.1.109 0 .036.017.068.043.088l-.095.114h-.643s.07.16.29.203c.066.064.238.182.238.182l-.098.119h.693v-.119c.168-.001.232-.134.254-.182.01-.02.012-.024.012 0 0 .085.123 0 .123 0s.205-.203.205-.397-.428.194-.428.194h-.29l-.13-.13z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.46 12.148c.009.02.016.035.016.056 0 .063-.267.155-.46.155s-.117-.155 0-.241c.117-.087-.01-.235-.117-.235-.103 0-.102-.145-.102-.261V11.151c0-.181.05-.16.143-.12.055.025.126.055.212.055.143 0 .151.033.173.123.013.054.03.13.087.23.09.162.072.2.043.258-.019.038-.043.086-.043.186 0 .166.029.225.047.265zm.236 1.16l.057-.614s-.056-.225.076-.225c.133 0 .34 1.075.414 1.507.048.275.004.326-.122.474-.072.084-.17.198-.292.4-.203.336-.19.533-.18.683.007.1.012.18-.05.266-.142.2-.201.01-.258-.174l-.013-.041c-.055-.173.195-.696.364-1.052l.061-.13c.16-.342.145-.461.076-.604-.069-.144-.133-.49-.133-.49z",
      fill: "#FFC6B5"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.02 19.37c0 .155-.12.282-.268.282-.147 0-.267-.127-.267-.283 0-.156.12-.283.267-.283.148 0 .267.127.267.283zm-1.422.078c-.12.1-.266.124-.326.052-.06-.072-.012-.212.108-.312s.266-.124.326-.052c.06.072.012.212-.108.312z",
      fill: "#FFD018"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.95 10.784s-.277.056-.185.195c.093.14-.12.104.185.122.306.017.39.129.348.211-.042.082-.075.286 0 .41.075.122.098.337.23.23.132-.108.386-.255.308-.447-.077-.193.032-.417-.138-.526-.17-.108-.207-.042-.305-.195-.097-.153-.24-.196-.341-.098l-.102.098z",
      fill: "#A95601"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24.896 12.177s-.558.672-.467.908c.092.237.228.25.16.586-.068.337.041.857-.16 1.52-.201.661-.333 2.214-.267 2.214s.158.858.079 1.243c-.08.385-.63.707-.08.707.552 0 .617.076.837 0 .22-.076.533.22.533 0s.023-.264.19-.264h.309c.148 0 .343.138.343-.19s.036-1.033-.154-1.58c-.19-.547-.125-.198-.31-.93-.111-.433-.196-.605-.263-.757-.047-.104-.178.079-.21-.084-.01-.056.08-.38.08-.422.007-.26.206-.304.206-.75 0-.52-.124-1.09 0-1.374.124-.285.43-.114.308-.391-.122-.278-.162-.436-.39-.436h-.744z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M20.986 20.145l.094-.124c1.336 1.244 2.571 1.864 3.705 1.864s2.516-.658 4.142-1.978l.086.131c-1.649 1.339-3.057 2.01-4.228 2.01-1.173 0-2.439-.636-3.799-1.903z",
      fill: "#272727"
    }
  )))
), a = c;
export {
  a as default
};
